import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectResume = (state : GlobalState) => state.hostess.resume;

export const hostessResumeSelector = createSelector(
    [selectResume],
    data => data
)
